import { render, staticRenderFns } from "./ReinstatementModal.vue?vue&type=template&id=06ee943c&"
import script from "./ReinstatementModal.vue?vue&type=script&lang=js&"
export * from "./ReinstatementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports